module.exports = __webpack_public_path__ + "149bbf5e3a1e55db7588dd7b2a90c9ac.svg";